import {incidentQueryService, incidentCmdService} from '../index'

class Incident {
    getRulesets = () => incidentQueryService.get('rulesets')
    getIncidents = (id, query) => incidentQueryService.get(`team/${id}/incidents?${query}`)
    createIncident = (id, data) => incidentCmdService.post(`team/${id}/incident`, data)
    createSchedule = (id, data) => incidentCmdService.post(`team/${id}/schedule`, data)
    updateSchedule = (id, data) => incidentCmdService.put(`team/${id}/schedule`, data)
    deleteSchedule = (id, query) => incidentCmdService.delete(`team/${id}/schedule?${query}`)
    getMembersSchedule = id => incidentQueryService.get(`customer/${id}/schedule`)
    updateIncident = (id, data) => incidentCmdService.put(`incident/${id}`, data)
    getIncidentActions = id => incidentQueryService.get(`incident/${id}/actions`)
    createRuleset = data => incidentCmdService.post('ruleset', data)
    updateRuleset = (id, data) => incidentCmdService.put(`ruleset/${id}`, data)
    deleteRuleset = id => incidentCmdService.delete(`ruleset/${id}`)
    getRulesetActions = id => incidentQueryService.get(`ruleset/${id}/actions`)
    updateRulesetActions = (id, data) => incidentCmdService.put(`ruleset/${id}/actions`, data)
    getWebhook = () => incidentQueryService.get('webhooks')
    createWebhook = () => incidentCmdService.post('webhook', {})
    getWebhookEvents = (id, query) => incidentQueryService.get(`webhook/${id}/events?${query}`)
    getVoices = () => incidentQueryService.get('voices/list')
    convertTTS = (data) => incidentCmdService.post('voice/tts', data)
    createPhoneCallTemplate = (data) => incidentCmdService.post('/phone-call/template', data)
    updatePhoneCallTemplate = (id, data) => incidentCmdService.put(`/phone-call/template/${id}`, data)
    deletePhoneCallTemplate = (id) => incidentCmdService.delete(`/phone-call/template/${id}`)
    getPhoneCallTemplates = () => incidentQueryService.get('/phone-call/templates')
}

export default new Incident()
